import { DatePicker as Wrapped, DatePickerProps } from 'antd'
import moment from 'moment'
import { FC } from 'react'
import IvyIcon from 'src/sdk/components/icon'
import './DatePicker.less'

export const { RangePicker } = Wrapped

export const DatePicker: FC<DatePickerProps> = (props) => {
  return (
    <Wrapped
      defaultValue={moment()}
      defaultPickerValue={moment()}
      picker={'date'}
      placeholder={'Date'}
      suffixIcon={<IvyIcon size={16} type={'application/calendar'} />}
      size={'middle'}
      allowClear={props.allowClear ?? false}
      {...props}
    />
  )
}
